export const OPERACAO_SIGLAS = {
    LIM: 'LIM',
    REST: 'REST',
    CFR: 'CFR',
    PMP: 'PMP',
    INV: 'INV',
    FAT: 'FAT',
    REQ: 'REQ',
};
